// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__3tOVC","load":"styles_load__Mjm0F","middle":"styles_middle__Z7q+p","full":"styles_full__QYprl","formLoaderWrapper":"styles_formLoaderWrapper__qFOK8"};